"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propsArray = exports.filterNonConcept = exports.filterConcept = exports.CONCEPT_CATEGORY_NAME = exports.CONCEPT_CATEGORY_ICON = exports.CONCEPT_CATEGORY = exports.CConcept = void 0;
var _block = require("./block");
var _publishable = require("./publishable");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let CONCEPT_CATEGORY = exports.CONCEPT_CATEGORY = /*#__PURE__*/function (CONCEPT_CATEGORY) {
  CONCEPT_CATEGORY["NONE"] = "none";
  CONCEPT_CATEGORY["TECHNICAL"] = "technical";
  CONCEPT_CATEGORY["PROTAGONIST"] = "protagonist";
  CONCEPT_CATEGORY["ENEMY"] = "enemy";
  CONCEPT_CATEGORY["ALGORITHM"] = "algorithm";
  CONCEPT_CATEGORY["SUBROUTINE"] = "subroutine";
  CONCEPT_CATEGORY["PROBLEM"] = "problem";
  return CONCEPT_CATEGORY;
}({});
let CONCEPT_CATEGORY_ICON = exports.CONCEPT_CATEGORY_ICON = /*#__PURE__*/function (CONCEPT_CATEGORY_ICON) {
  CONCEPT_CATEGORY_ICON["none"] = "fas fa-lightbulb";
  CONCEPT_CATEGORY_ICON["technical"] = "fas fa-microchip";
  CONCEPT_CATEGORY_ICON["protagonist"] = "pi pi-user";
  CONCEPT_CATEGORY_ICON["enemy"] = "fas fa-skull-crossbones";
  CONCEPT_CATEGORY_ICON["algorithm"] = "fas fa-cogs";
  CONCEPT_CATEGORY_ICON["subroutine"] = "fas fa-cog";
  CONCEPT_CATEGORY_ICON["problem"] = "pi pi-trophy";
  return CONCEPT_CATEGORY_ICON;
}({});
let CONCEPT_CATEGORY_NAME = exports.CONCEPT_CATEGORY_NAME = /*#__PURE__*/function (CONCEPT_CATEGORY_NAME) {
  CONCEPT_CATEGORY_NAME["none"] = "None";
  CONCEPT_CATEGORY_NAME["technical"] = "Technical";
  CONCEPT_CATEGORY_NAME["protagonist"] = "Protagonist";
  CONCEPT_CATEGORY_NAME["enemy"] = "Enemy";
  CONCEPT_CATEGORY_NAME["algorithm"] = "Algorithm";
  CONCEPT_CATEGORY_NAME["subroutine"] = "Subroutine";
  CONCEPT_CATEGORY_NAME["problem"] = "Problem";
  return CONCEPT_CATEGORY_NAME;
}({});
class CConcept {
  constructor() {
    _defineProperty(this, "conceptType", null);
    // the category of the concept
    _defineProperty(this, "standalone", null);
  } // is the concept able to stand alone, (true) or does it only make sense with the concept it refines (false)
  //abbreviation: string | null = null; // the abbreviation of the concept
}
exports.CConcept = CConcept;
;
;
const optionalKeys = [
// enter the key of the interface that is not in the class
'aspects', 'aspectParent'].concat(_block.optionalKeys).concat(_publishable.optionalKeys);

/**
 * The type of an array of the properties
 */

/**
 * An array of the properties
 */
//const propsArray: ArrConcept = Object.keys(new CConcept()) as ArrConcept;
/* multiple parent classes */
const propsArray = exports.propsArray = [...Object.keys(new CConcept()), ...Object.keys(new _block.CBlock()), ...Object.keys(new _publishable.CPublishable())];

/**
 * Get the properties from a bigger object
 * when collect==true, then also collect the optional keys that are only defined in the interface but not in the class
 */
const filterConcept = (props, {
  fallback = {},
  override = {}
} = {}, collect = false) => {
  const data = Object.assign(propsArray.concat(collect ? optionalKeys : []).reduce((r, k) => {
    // do not overwrite the IEntry values with undefined
    return _objectSpread(_objectSpread({}, r), {}, {
      [k]: function (_props$k, _props$k$localeCompar) {
        if (props[k] !== undefined && ((_props$k = props[k]) === null || _props$k === void 0 || (_props$k$localeCompar = _props$k.localeCompare) === null || _props$k$localeCompar === void 0 ? void 0 : _props$k$localeCompar.call(_props$k, '')) !== 0) {
          return props[k];
        }
        if (fallback[k] !== undefined) {
          return fallback[k];
        }
        if (r[k] !== null) {
          return r[k];
        }
        return undefined;
      }()
    });
  }, new CConcept()), override);
  return data;
};
exports.filterConcept = filterConcept;
const filterNonConcept = props => Object.keys(props).reduce((r, k) => {
  return Object.assign(r, !propsArray.includes(k) ? {
    [k]: props[k]
  } : {});
}, {});
exports.filterNonConcept = filterNonConcept;